import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

const getInitialDark = () => {
  try {
    const stored = localStorage.getItem("darkMode");
    if (stored !== null) return stored === "true";
  } catch (e) {
    // storage unavailable, fall through to system preference
  }
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
};

const Header = () => {
  const [darkMode, setDarkMode] = useState(getInitialDark);

  useEffect(() => {
    document.body.classList.toggle("dark", darkMode);
    try {
      localStorage.setItem("darkMode", darkMode);
    } catch (e) {
      // ignore
    }
  }, [darkMode]);

  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link to="/" className="brand">
          <img src="/logo192.png" alt="" width={36} height={36} />
          <span>Northwind</span>
        </Link>
        <nav className="site-nav">
          <NavLink to="/" end className="nav-link">
            Apps
          </NavLink>
          <NavLink to="/privacy" className="nav-link">
            Privacy
          </NavLink>
          <a href="/#contact" className="nav-link">
            Contact
          </a>
          <button
            className="theme-toggle"
            onClick={() => setDarkMode((d) => !d)}
            aria-label="Toggle dark mode"
          >
            {darkMode ? "🌙" : "☀️"}
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
